export type { CardProps } from './Card.types'
export { default as Card } from './Card'